import { isBrowser } from '~/utilities/helpers';

export const CONSENT_STORAGE_KEY = 'howco_consent';

export const defaultConsent = {
    decision: false,
    marketing: false
};

export const getConsent = () => {
    if (!isBrowser()) {
        return defaultConsent;
    }

    try {
        const match = document.cookie
            .split('; ')
            .find((row) => row.startsWith(CONSENT_STORAGE_KEY + '='));

        if (!match) {
            return defaultConsent;
        }

        const parsed = JSON.parse(decodeURIComponent(match.split('=')[1]));

        return {
            decision: Boolean(parsed.decision),
            marketing: Boolean(parsed.marketing)
        };
    } catch (error) {
        return defaultConsent;
    }
};

export const setConsent = ({ decision, marketing }) => {
    const consent = {
        decision: Boolean(decision),
        marketing: Boolean(marketing)
    };

    if (isBrowser()) {
        try {
            document.cookie = `${CONSENT_STORAGE_KEY}=${encodeURIComponent(
                JSON.stringify(consent)
            )}; max-age=31536000; path=/; SameSite=Lax; Secure`;
        } catch (error) {
            // Ignore write failures.
        }
    }

    return consent;
};

export const clearConsent = () => {
    if (isBrowser()) {
        try {
            document.cookie = `${CONSENT_STORAGE_KEY}=; max-age=0; path=/; SameSite=Lax; Secure`;
        } catch (error) {
            // Ignore removal failures.
        }
    }
};
